export default __webpack_public_path__ + "static/media/booking.e038e5e3.png";